import "../styles/booking-home.css";
import React, { useState, useEffect } from "react";
import BookingController from "../services/booking-controller";
import { getToken } from "../utility";

export default function BookingHome(props) {
	const bookingController = new BookingController();
	const [advertisements, setAdvertisements] = useState([]);
	const [topResidences, setTopResidences] = useState([]);
	const [cities, setCities] = useState([]);
	const [offResidences, setOffResidences] = useState([]);

	const getData = async function () {
		try {
			// getAdvertisements
			const advertisementsResult = await bookingController.getAdvertisements();
			if (advertisementsResult.isSuccess === false)
				throw advertisementsResult.message;
			setAdvertisements(advertisementsResult.value);
			// getTopResidences
			const topResidencesResult = await bookingController.getTopResidences();
			if (topResidencesResult.isSuccess === false)
				throw topResidencesResult.message;
			setTopResidences(topResidencesResult.value);
			// getCities
			const citiesResult = await bookingController.getCities();
			if (citiesResult.isSuccess === false) throw citiesResult.message;
			setCities(citiesResult.value);
			// getOffResidences
			const offResidencesResult = await bookingController.getOffResidences();
			if (offResidencesResult.isSuccess === false)
				throw offResidencesResult.message;
			setOffResidences(offResidencesResult.value);
			//
		} catch (error) {
			alert(error.toString());
		}
	};

	useEffect(() => {
		getData();
	}, []);

	if (!getToken()) {
		window.location = "/#/login?returnUrl=/booking-home";
		return <></>;
	}
	return (
		<article className="bkh-home">
			{/* <div className="bkh-ads">
				<ul className="bkh-slider">
					{advertisements
						.filter(
							(item) => advertisements.indexOf(item) < advertisements.length - 2
						)
						.map((item) => (
							<li key={item.linkUrl}>
								<a href={item.linkUrl} target="_blank">
									<img src={item.imageUrl} />
								</a>
							</li>
						))}
				</ul>
				<ol className="bkh-side">
					{advertisements
						.filter(
							(item) =>
								advertisements.indexOf(item) >= advertisements.length - 2
						)
						.map((item) => (
							<li key={item.linkUrl}>
								<a href={item.linkUrl} target="_blank">
									<img src={item.imageUrl} />
								</a>
							</li>
						))}
				</ol>
			</div> */}

			{/* <div className="bkh-top">
				<div className="bkh-header">
					<h2>اماکن اقامتی پر بازدید</h2>
					<a href="/#/booking-all">مشاهده همه اماکن اقامتی</a>
				</div>

				<Carousel
					value={topResidences}
					numVisible={4}
					showIndicators={false}
					itemTemplate={(item) => (
						<a 
							className="bkh-top-item"
							href={`/#/booking-detail/?residenceId=${item.residenceId}`}
							style={{ backgroundImage: `url(${item.imageUrl})` }}
						>
							{item.maxOffPercent > 0 ? (
								<span className="bkh-off">تا {item.maxOffPercent}% تخفیف</span>
							) : (
								<span className="bkh-off">تا {item.maxOffPercent}% تخفیف</span>
							)}
							<span></span>
							<span className="bkh-rate">
								{Array(item.rate)
									.fill(1)
									.map((rateItem,index) => (
										<i key={index} className={PrimeIcons.STAR_FILL}></i>
									))}
							</span>
							<h2>{item.name}</h2>
							<span className="bkh-price">
								از <b>{item.minPrice.toLocaleString("fa-IR")} ریال</b>/ شبی
							</span>
						</a>
					)}
				></Carousel>
			</div> */}

			{/* <div className="bkh-cities">
				<div className="bkh-header">
					<h2>اماکن اقامتی کشور</h2>
					<span></span>
					<a href="/#/booking-cities">مشاهده همه شهر ها</a>
					<a href="/#/booking-map">نقشه راهنمای اماکن اقامتی</a>
				</div>
				<Carousel
					value={cities}
					numVisible={4}
					showIndicators={false}
					itemTemplate={(item) => (
						<a className="bkh-city-item">
							<img src={item.imageUrl} />

							<div>
								<h2>{item.name}</h2>

								{item.maxOffPercent > 0 ? (
									<span className="bkh-off">تا {item.maxOffPercent}% تخفیف</span>
								) : (
									<span className="bkh-off">بدون تخفیف</span>
								)}
							</div>
						</a>
					)}
				></Carousel>
			</div> */}

			<div className="bkh-off-list">
				<div className="bkh-header">
					<h2>امکان اقامتی</h2>
					<a href="/#/booking-cities">مشاهده همه اقامتگاه ها</a>
				</div>
				<ul>
					{offResidences.map((item) => (
						<li key={item.residenceId}>
							<a href={`/#/booking-detail/?residenceId=${item.residenceId}`}>
								<img src={item.imageUrl} />
								{/* <span className="bkh-rate">
									{Array(item.rate)
										.fill(1)
										.map((rateItem,index) => (
											<i key={index} className={PrimeIcons.STAR_FILL}></i>
										))}
								</span> */}
								<h2>{item.name}</h2>
								<p>{item.shortAddress}</p>
								{/* <span className="bkh-price">
									از <b>{item.minPrice.toLocaleString("fa-IR")} ریال</b>/ 1 شب
								</span> */}
								{/* {item.maxOffPercent > 0 ? (
									<span className="bkh-off">تا {item.maxOffPercent}% تخفیف</span>
								) : (
									<span className="bkh-off">تا {item.maxOffPercent}% تخفیف</span>
								)} */}
							</a>
						</li>
					))}
				</ul>
			</div>
		</article>
	);
}
